
function menu(parent) {
    
    const DATASET_FOCUS = 'focusindex';
    const STATE_CLOSED = 'tw-arrow-down';
    const STATE_OPEN = 'tw-arrow-up';
    const STATE_FOCUS = 'tw-ddlNav-focus';
    const items = [];    
    const mainSection = document.querySelector('body > main');

    const getParentHeight = () => {
        return parent.parentElement.getBoundingClientRect().height;
    };

    if (!mainSection) {
        console.warn('ddlNav.js -> Main section cannot be found.');
        return;
    }
    
    const anchorTo = (item) => {
        
        const element = positions.find(x => { return x.id === item.anchor });
        
        if (element) {

            let position = 0;

            if (element.id === items[0].anchor) {
                position = 0;
            } else {

                const mainNavHeight = mainSection.offsetTop;
                let offset = parentHeight + mainNavHeight;
                if (parentHeight > mainNavHeight) {
                    offset += parentHeight - mainNavHeight;
                }

                position = element.top - offset;
            }
            
            mainSection.scrollTo(0, position);
        }
    }

    const clamp = (value) => Math.max(0, value);

    const isBetween = (value, floor, ceil) => value >= floor && value <= ceil;

    const getPosition = (anchor) => {
        
        const element = document.getElementById(anchor);

        if (!element)
            return { id: anchor, top: -1, bottom: -1 };

        const rect = element.getBoundingClientRect();
        const top = clamp(rect.top);
        const bottom = clamp(rect.bottom);

        return { id: anchor, top, bottom };        
    };

    const listener = (positions, scroll) => {

        if (!isScrolling) {

            const mainNavHeight = mainSection.offsetTop;
            let offset = parentHeight + mainNavHeight;
            if (parentHeight > mainNavHeight) {
                offset += parentHeight - mainNavHeight;
            }

            const position = scroll + offset;

            const anchorInRange = positions.find(({ top, bottom }) => isBetween(position, top, bottom));

            if (anchorInRange) {

                const anchorItems = this.GetItemsByAnchor(anchorInRange.id);

                for (let i = 0, l = anchorItems.length; i < l; i++) {

                    if (anchorItems[i].type === 'mobile')
                        this.SetFocus(anchorItems[i]);

                    this.SetFocusOnItem(anchorItems[i]);
                }

            }
        }
    };

    const setListener = (event) => {

        listener(positions, event.srcElement.scrollTop);
    };

    const setPositions = () => {

        positions = [];

        for (let i = 0, l = items.length; i < l; i++) {

            if (items[i].anchor !== '') {
                const anchor = items[i].anchor;
                const position = getPosition(anchor);
                positions.push(position);
            }
        }
    };

    this.FocusedItem = parent.querySelector(`[data-${DATASET_FOCUS}]`);

    if (!this.FocusedItem) {
        console.warn
            (`The ddlNav feature is missing an element to apply focus. Attribute should be data-${DATASET_FOCUS}`);
        return;
    }
        
    this.CloseMenu = () => {

        this.FocusedItem.classList.remove(STATE_OPEN);
        this.FocusedItem.classList.add(STATE_CLOSED);

        for (let i = 0, l = items.length; i < l; i++) {
            if (items[i].type === 'mobile')
                items[i].element.style.display = 'none';         
        }
    };

    this.GetItem = (index) => {

        for (let i = 0, l = items.length; i < l; i++) {
            if (items[i].index === index)
                return items[i];
        }

        return undefined;
    };

    this.GetItemsByAnchor = (anchor) => {

        const anchorItems = [];

        for (let i = 0, l = items.length; i < l; i++) {
            if (items[i].anchor === anchor)
                anchorItems.push(items[i]);
        }

        return anchorItems;
    }

    this.GoTo = (item) => {

        if (item.anchor !== '') {
            anchorTo(item);
        } else {
            location.href = item.href;
        }
    };

    this.IsOpen = () => {
        return this.FocusedItem.classList.contains('tw-arrow-up');
    };


    let initialWidth = window.innerWidth;

    this.OnResize = () => {
        let currentWidth = window.innerWidth;
        let widthDifference = Math.abs(currentWidth - initialWidth);

        if (new Date() - resizeRunTime < resizeDelta) {
            setTimeout(this.OnResize, resizeDelta);
        } else {
            if (widthDifference > 500) {
                location.reload();
                console.log("ACTIVE!");
            }
            // Update initial width and resizeRunTime
            initialWidth = currentWidth;
            resizeRunTime = new Date();
        }
    };

    this.OpenMenu = () => {

        this.FocusedItem.classList.remove(STATE_CLOSED);
        this.FocusedItem.classList.add(STATE_OPEN);

        for (let i = 0, l = items.length; i < l; i++) {   
            if(items[i].type === 'mobile')
                items[i].element.style.display = 'block';
        }
    };
    
    this.Set = (index) => {

        if (isScrolling) {
            setTimeout(() => { this.Set(index); }, 100);
            return;
        }

        const item = this.GetItem(index);

        if (item === undefined)
            return;

        this.SetFocus(item)

        this.SetFocusOnItem(item);

        isScrolling = true;

        this.GoTo(item);

        setTimeout(() => { isScrolling = false; }, 800);

        this.CloseMenu();
    };

    this.SetFocus = (item) => {

        this.FocusedItem.innerHTML = item.element.innerHTML;
        this.FocusedItem.dataset[DATASET_FOCUS] = item.index;
    };

    this.SetFocusOnItem = (item) => {

        item.isSelected = true;

        for (let i = 0, l = items.length; i < l; i++) {

            if (items[i].anchor !== '' && items[i].anchor === item.anchor) {                
                items[i].element.classList.add(STATE_FOCUS);                
            } else {
                items[i].element.classList.remove(STATE_FOCUS);
                items[i].isSelected = false;
            }
        }
    };

    this.SetScrollListener = () => {

        if (isListenerSet)
            mainSection.removeEventListener('scroll', setListener);

        setPositions();

        mainSection.addEventListener('scroll', setListener);

        resizeScrolling = true;
        isListenerSet = true;
    };

    this.ToggleMenu = () => {

        const isOpen = this.IsOpen();

        if (isOpen)
            this.CloseMenu();
        else
            this.OpenMenu();
    };

    const indexItems = parent.querySelectorAll('[data-index]');

    let isSelected = undefined;
    let parentHeight = getParentHeight();
    let isScrolling = false;
    let isListenerSet = false;
    let isResizing = false;
    let positions = [];
    let resizeDelta = 500;
    let resizeRunTime;
    let resizeScrolling = false;
    let resizeTimeOut = false;
    
    for (let i = 0, l = indexItems.length; i < l; i++) {

        const index = parseInt(indexItems[i].dataset['index']);
        if (isNaN(index))
            continue;

        const href = indexItems[i].dataset['href'];
        if (!href)
            continue;

        const element = indexItems[i];
        const self = this;
        const anchor = href.indexOf('#') === 0 ? href.substr(1, href.length) : '';
        const type = indexItems[i].dataset['type'] === 'desktop' ? 'desktop' : 'mobile';
        
        element.addEventListener('click', (e) => { self.Set(index); });

        isSelected = isSelected === undefined && element.dataset['selected'] === 'true';

        items.push({ index, href, isSelected, anchor, type, element });
    } 

    this.FocusedItem.addEventListener('click', (e) => { this.ToggleMenu(); });

    window.addEventListener('resize', (event) => {
        resizeRunTime = new Date();
        if (!resizeTimeOut) {
            resizeTimeOut = true;
            setTimeout(this.OnResize, resizeDelta);
        }
    });
}

export default async element => { // feature="ddlNav"

    const ddlMenu = new menu(element);

    const firstItem = ddlMenu.GetItem(0);

    if (firstItem !== undefined && !firstItem.isSelected && ddlMenu.IsOpen())
        ddlMenu.Set(0);

    ddlMenu.SetScrollListener();
};